import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nexus_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Tenant Switch — read-only impersonation for Pandora internal admins
  const tenantSwitch = localStorage.getItem("nexus_tenant_switch");
  if (tenantSwitch) config.headers["X-Tenant-Switch"] = tenantSwitch;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("nexus_token");
        localStorage.removeItem("nexus_user");
        window.location.href = "/login";
      }
    }
    if (status === 402) {
      // Quota / plan-limit exceeded. Surface a clean upgrade CTA.
      const d = err.response?.data?.detail;
      const msg = (d && typeof d === "object" && d.message)
        ? d.message
        : (typeof d === "string" ? d : "You've hit a plan limit. Upgrade to continue.");
      try {
        toast.error(msg, {
          duration: 7000,
          action: {
            label: "Upgrade",
            onClick: () => { window.location.href = "/pricing"; },
          },
        });
      } catch { /* toast may not be mounted yet */ }
    }
    return Promise.reject(err);
  }
);

export default api;
